module.exports = __webpack_public_path__ + "static/media/eg.6b83ab95.svg";